import { render, staticRenderFns } from "./systemInfoManageList.vue?vue&type=template&id=dea4bdfc&scoped=true"
import script from "./systemInfoManageList.vue?vue&type=script&lang=js"
export * from "./systemInfoManageList.vue?vue&type=script&lang=js"
import style0 from "./systemInfoManageList.vue?vue&type=style&index=0&id=dea4bdfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea4bdfc",
  null
  
)

export default component.exports